import EventEmitter from "base/EventEmitter";

export default class FormInput extends EventEmitter {
    constructor($input, options, form) {
        super();

        this.eventValidate = this.eventValidate.bind(this);
        this.updateHasValue = this.updateHasValue.bind(this);

        options = $.extend(true, {}, FormInput.defaultOptions, "object" === typeof options ? options : {});

        this.hasHadValue = false;

        this.options = options;
        this.form = form;

        this.$input = $input;
        this.type = $input.is("[data-type]") ? $input.attr("data-type") : $input.attr("type");
        let $message;

        if ('function' === typeof options.getMessageElement) {
            $message = options.getMessageElement.call(this);
        } else if ($input.is("[type='hidden']") && !$input.is("[data-has-message]")) {
            $message = $("<div>");
        } else {
            let $level = $input;
            do {
                $level = $level.parent();
                $message = $level.find(options.getMessageElement);


            } while ($level.length === 1 && $message.length === 0);
            if ($message.length > 1) {
                console.warn("Multiple inline validation elements for input, omitting", this.$input[0], $message.get());
                $message = $("<div>");
            }
            $message.hide();
        }

        this.$message = $message.hide();

        $input.on(options.events, this.eventValidate).data("Validator", this);
        $input.on("input", this.updateHasValue);

        if (this.options.interceptBrowserValidation) {
            $input.on("invalid", () => false);
        }

        this.updateHasValue();
    }

    updateHasValue() {
        if (this.$input.is(":checkbox,:radio")) {
            if (this.$input.is(":checked")) {
                this.hasHadValue = true;
            }
        } else if (this.$input.val() !== "") {
            this.hasHadValue = true;
        }

        if (this.hasHadValue) {
            this.$input.off("input", this.updateHasValue);
        }
    }

    /**
     * Reset this input's state to that of page load
     *
     * *NOTE:* This doesn't impact the actual _element's_ state
     */
    reset() {
        this.hasHadValue = false;
        this.$input.off("input", this.updateHasValue);
        this.$input.on("input", this.updateHasValue);

        this.updateHasValue();
        this.hideMessage();
    }


    /**
     * @param {Event} e
     * @return {boolean}
     */
    isHardValidationEvent(e) {
        const type = e.type;

        // These events are always considered soft validation events
        if (this.options.softEvents.split(" ").indexOf(type) !== -1) {
            return false;
        }

        if (this.options.validateEmptyOnBlur === false && type === "blur" && this.hasHadValue === false) {
            // We only validate on blur if the input has had a value
            return false;
        }

        return true;
    }

    getMessage(type, context = {}) {
        return 'function' === typeof this.options.getMessage ? this.options.getMessage.call(this, type, context, this) : this.options.getMessage;
    }

    getOperator() {
        return 'function' === typeof this.options.getOperator ? this.options.getOperator.call(this) : this.options.operator;
    }

    getAction() {
        return 'function' === typeof this.options.getAction ? this.options.getAction.call(this) : this.options.action;
    }

    valid() {
        return this._validate().valid;
    }

    eventValidate(e) {
        this.validate(this.isHardValidationEvent(e));
        return true;
    }

    validate(hard = true) {
        let result = this._validate(hard);

        if (result.valid) {
            if (this.emit("valid", result)) {
                if (this.options.hasSuccess && !result.hideMessage) {
                    this.showMessage(this.getMessage("success"), "valid");
                } else {
                    this.hideMessage();
                }
            }
        } else {
            if (hard && this.emit("invalid", result)) {
                this.showMessage(result.message, "invalid");
            }
        }

        return result.valid;
    }

    _validate(hard = true) {
        let valid = true;
        let message = "";
        let value;
        let hideMessage = false;

        let $input = this.$input;

        if ($input.is(":disabled")) {
            return {
                valid,
                message,
                hideMessage,
            };
        }

        if ("function" === typeof this.options.customValidator) {
            let result = this.options.customValidator.call(this, this);

            if ("object" === typeof result) {
                valid = result.valid;
                message = result.message;
                hideMessage = result.hideMessage;
            } else {
                valid = !!result;

                if (!valid) message = this.getMessage("empty");
            }
        } else {
            if ($input.is(":checkbox") || $input.is(":radio")) {
                value = this.form.$form.find("input[name='" + $input.attr("name") + "']:checked").length > 0;
                if (!value && !$input.is("[data-optional]")) {
                    valid = false;
                    message = this.getMessage("unchecked");
                } else {
                    valid = true;
                }
            } else {
                value = $input.val();
                if ("string" === typeof value) {
                    value = value.trim();
                }

                if ("undefined" === typeof value || value === null || value.length === 0) {
                    if (!$input.is("[data-optional]")) {
                        valid = false;
                        message = this.getMessage("empty");
                    } else {
                        valid = true;
                        hideMessage = true;
                    }
                } else {
                    switch (this.type) {
                        case "email":
                            if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)) {
                                valid = false;
                                message = this.getMessage("invalidEmail");
                            }
                            break;
                        case "number":
                            value = value.trim();
                            let number = $input.is("[data-number]") ? $input.attr("data-number") : "both";

                            if (isNaN(parseFloat(value)) || !/^-?[0-9]*(\.?[0-9]*)?$/.test(value)) {
                                valid = false;
                                message = this.getMessage("invalidNumber");
                            } else {
                                value = parseFloat(value);

                                if (number === "positive" && value < 0) {
                                    valid = false;
                                    message = this.getMessage("invalidPositiveNumber");
                                } else if (number === "negative" && value > 0) {
                                    valid = false;
                                    message = this.getMessage("invalidNegativeNumber");
                                } else {
                                    let min = $input.is("[min]") ? parseFloat($input.attr("min")) : null;
                                    let max = $input.is("[max]") ? parseFloat($input.attr("max")) : null;

                                    if (min !== null && value < min) {
                                        valid = false;
                                        message = this.getMessage("invalidNumberMin", {
                                            min,
                                            max,
                                        });
                                    } else if (max !== null && value > max) {
                                        valid = false;
                                        message = this.getMessage("invalidNumberMax", {
                                            min,
                                            max,
                                        });
                                    }
                                }
                            }
                            break;
                        case "tel":
                            if (!(/^\d{7,}$/).test(value.replace(/[\s()+\-\.]|ext/gi, ""))) {
                                valid = false;
                                message = this.getMessage("invalidPhone");
                            }
                            break;
                        case "url":
                            if (!/^((http[s]?:)?\/\/)?.+$/.test(value)) {
                                valid = false;
                                message = this.getMessage("invalidUrl");
                            }
                            break;
                        case "slug":
                            if (!/^[^ ]+$/.test(value)) {
                                valid = false;
                                message = this.getMessage("invalidSlugSpaces");
                            } else if (!/^[a-z0-9\-/]+$/.test(value)) {
                                valid = false;
                                message = this.getMessage("invalidSlug");
                            }
                            break;
                        case "date":
                            if (!/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(value)) {
                                valid = false;
                                message = this.getMessage("invalidDate");
                            }
                            break;
                        case "time":
                            let regex = new RegExp("^[0-9]{2}:[0-9]{2}" + ($input.is("[data-short-time]") ? "" : ":[0-9]{2}") + "$");
                            if (!regex.test(value)) {
                                valid = false;
                                message = this.getMessage("invalidTime");
                            }
                            break;
                        case "set-password":
                            if (value.length < 8) {
                                valid = false;
                                message = this.getMessage("passwordLength");
                            }
                            break;
                        case "full-name":
                            const name_parts = ValueHelper.process_full_name(value);

                            if(!name_parts.first_name || !name_parts.last_name) {
                                valid = false;
                                message = this.getMessage("invalidFullName");
                            }
                            break;
                        default:
                            if ($input.is("min-length")) $input.attr("data-min-length", $input.attr("min-length"));
                            if ($input.is("max-length")) $input.attr("data-max-length", $input.attr("max-length"));

                            if ($input.is("[data-min-length]")) {
                                let minLength = parseInt($input.attr("data-min-length"));

                                if (value.trim().length < minLength) {
                                    valid = false;
                                    message = this.getMessage("textTooShort", {minLength: minLength});
                                }
                            }
                            if ($input.is("[data-max-length]")) {
                                let maxLength = parseInt($input.attr("data-max-length"));

                                if (value.trim().length > maxLength) {
                                    valid = false;
                                    message = this.getMessage("textTooLong", {maxLength: maxLength});
                                }
                            }

                            let wordCount = $input.is("[data-min-words]") || $input.is("[data-max-words]") ? $input.val().trim().split(" ").length : 0;
                            if ($input.is("[data-min-words]")) {
                                let minWords = parseInt($input.attr("data-min-words"));
                                if (wordCount < minWords) {
                                    valid = false;
                                    message = this.getMessage("textTooFewWords", {
                                        wordCount,
                                        minWords,
                                    });
                                }
                            }
                            if ($input.is("[data-max-words]")) {
                                let maxWords = parseInt($input.attr("data-max-words"));
                                if (wordCount > maxWords) {
                                    valid = false;
                                    message = this.getMessage("textTooManyWords", {
                                        wordCount,
                                        maxWords,
                                    });
                                }
                            }

                            if ($input.is("[data-regex]")) {
                                let regex = new RegExp($input.attr("data-regex"), $input.is("[data-regex-flags]") ? $input.attr("data-regex-flags") : "");

                                if (!regex.test(value)) {
                                    valid = false;
                                    message = this.getMessage("invalidRegex", {regex: regex});
                                }
                            }
                            break;
                    }
                }
            }
        }

        let event = {
            valid,
            message,
            value,
            hard,
        };

        valid = this.emit("validate", event) && event.valid;
        return {
            valid,
            message: event.message,
            hideMessage,
        };
    }

    showMessage(message, type) {
        if (!message) {
            this.hideMessage();
            return;
        }
        this.$message.text(message).removeClass(this.options.classes.valid + " " + this.options.classes.invalid).addClass(type === "valid" ? this.options.classes.valid : this.options.classes.invalid).show();
        if (type === "invalid") {
            this.$input.addClass(this.options.classes.inputInvalid).removeClass(this.options.classes.inputValid);
        } else {
            this.$input.removeClass(this.options.classes.inputInvalid).addClass(this.options.classes.inputValid);
        }
        this.emit("showMessage", {
            message,
            type,
        });
    }

    hideMessage() {
        this.$input.removeClass(this.options.classes.inputInvalid + " " + this.options.classes.inputValid);
        this.$message.hide();
        this.emit("hideMessage");
    }

    getName() {
        if (this.$input.is("[data-name]")) {
            return this.$input.attr("data-name");
        } else if (this.$input.is("[name]")) {
            // Convert camel case to separated words
            return this.$input.attr("name").replace(/(\B[A-Z]+?(?=[A-Z][^A-Z])|\B[A-Z]+?(?=[^A-Z]))/g, " $1").replace(/_/g, " ").toLowerCase();
        } else {
            return "value";
        }
    }

    destroy() {
        super.destroy();

        this.$input.off(this.options.events, this.eventValidate).removeData("Validator");
        this.$input.off("input", this.updateHasValue);
    }
}


FormInput.defaultOptions = {
    messages: {
        empty: "Please {action} {operator} {name}",
        unchecked: "Please {action} an option",
        invalidEmail: "Please {action} a valid email address",
        success: "",
        invalidNumber: "Please {action} a number",
        invalidPositiveNumber: "Please {action} a positive number",
        invalidNegativeNumber: "Please {action} a negative number",
        invalidNumberMin: "Please {action} at least {min}",
        invalidNumberMax: "Please {action} at most {max}",
        invalidPhone: "Please {action} a valid phone number",
        invalidUrl: "Please {action} a valid URL",
        invalidSlug: "Please {action} a valid URL. It must only contain letters, numbers, forward slashes and hyphens.",
        invalidSlugSpaces: "The Url must not contain spaces",
        invalidDate: "Please {action} a valid date",
        invalidTime: "Please {action} a valid time",
        invalidRegex: "Sorry, this value doesn't look correct",
        passwordLength: "Your password should be at least 8 characters long",
        textTooShort: "{operator} {name} must be at least {minLength} characters",
        textTooLong: "{operator} {name} must cannot be longer than {maxLength} characters",
        textTooFewWords: "{operator} {name} must have at least {minWords} words",
        textTooManyWords: "{operator} {name} cannot be longer than {maxWords} words",
        invalidFullName: "Please enter a full name",
    },
    operator: "the" /* Template value for messages, can be a function */,
    hasSuccess: true /* Whether to show a success message */,
    getMessage: function (type, context = {}) {
        context = $.extend(true, {
            operator: this.getOperator(),
            name: this.getName(),
            action: this.getAction(),
        }, context);
        let message = this.options.messages[type];

        if ('undefined' === typeof message) {
            console.error("Undefined error message", {
                type,
                context,
            });
            return "Undefined error message: " + type;
        }
        if (message instanceof Function) {
            message = message.call(this, type, context, this);
        }

        $.each(context, (key, value) => {
            message = message.replace(new RegExp("{" + key + "}", "g"), value);
        });

        // Ensure the first character is upper case
        message = message.charAt(0).toUpperCase() + message.slice(1);

        return message;
    },
    getOperator: function () {
        return 'function' === typeof this.options.operator ? this.options.operator.call(this) : this.options.operator;
    },
    getAction: function () {
        if (this.options.action) {
            return this.options.action;
        }

        if (this.$input.is("[data-action]")) {
            return this.$input.attr("data-action");
        }

        return this.$input.is(":radio,:checkbox,select") ? "select" : "enter";
    },
    getMessageElement: ".js-inline-validation"  /* Selector or function to find the element to use for inline validation */,
    events: "change blur keyup validate validate-soft" /* Events that should trigger validation */,
    softEvents: "keypress keydown keyup validate-soft" /* Events that should hide an error but not show one */,
    classes: {
        valid: "form__inline-validation--success",
        invalid: "form__inline-validation--error",
        inputValid: "form__input--success",
        inputInvalid: "form__input--error",
    },
    validateEmptyOnBlur: false /* Whether we should wait until the form is submitted before validating empty inputs */,
    interceptBrowserValidation: true /* Whether we should intercept and disable default inline validation */,
};
